<button (click)="onToggle()"
        id="catalog_search-form_btn_toggle-simple-advanced-form"
        mat-button>
  {{ (mode === 'simple' ? 'catalog.search.switch_to_advanced_mode' : 'catalog.search.switch_to_simple_mode') | transloco }}
</button>
